module.exports = __webpack_public_path__ + "img/bgw3.13b70e15.jpg";